import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { createInitialStatePart, setReducerState } from '../utils/reduxUtils';
import { LoadAppDetailsAction } from '../actionTypes/apps';
import { AppsInitialState, AppListState, AppState } from '../models/apps';
import { ListResponse, FailedResponse } from '../models/common';
import { RootState } from '../store';

const STATE_KEY = 'appDetails';
const initialState = {
  ...createInitialStatePart('appDetails'),
  ...createInitialStatePart('appList'),
  appDescription: '',
  isVisibleSecretModal: false,
  isVisibleDeleteAppModal: false,
  isVisibleCreateAppModal: false,
};

const appDetails = createSlice({
  name: STATE_KEY,
  initialState: initialState as AppsInitialState,
  reducers: {
    loadAppList: (state) => {
      return setReducerState('loading', 'appList', { state });
    },
    loadAppListSuccess: (state, action: PayloadAction<ListResponse<AppListState>>) => {
      return setReducerState('loaded', 'appList', { state, data: action.payload });
    },
    loadAppListFail: (state, action: PayloadAction<FailedResponse>) => {
      return setReducerState('error', 'appList', { state, error: action.payload });
    },
    loadAppDetails: (state, action: PayloadAction<LoadAppDetailsAction>) => {
      return setReducerState('loading', 'appDetails', { state, action });
    },
    loadAppDetailsSuccess: (state, action: PayloadAction<ListResponse<AppState>>) => {
      const appDescription = action.payload.data.description;
      return {
        ...setReducerState('loaded', 'appDetails', { state, data: action.payload }),
        appDescription
      };
    },
    loadAppDetailsFail: (state, action: PayloadAction<FailedResponse>) => {
      return setReducerState('error', 'appDetails', { state, error: action.payload });
    },
    updateAppDetails: (state, action) => {
      return setReducerState('loading', 'appDetails', { state, action });
    },
    updateAppDetailsSuccess: (state, action: PayloadAction<ListResponse<AppState>>) => {
      const appDescription = action.payload.data.description;
      return {
        ...setReducerState('loaded', 'appDetails', { state, data: action.payload }),
        appDescription
      };
    },
    updateAppDetailsFail: (state, action: PayloadAction<FailedResponse>) => {
      return setReducerState('error', 'appDetails', { state, error: action.payload });
    },
    createApp: (state) => {
      return state;
    },
    createAppSuccess: (state, { payload }) => {
      return { ...state, appDetails: payload };
    },
    createAppFail: (state, action: PayloadAction<FailedResponse>) => {
      return setReducerState('error', 'appDetails', { state, error: action.payload });
    },
    deleteApp: (state) => {
      return state;
    },
    deleteAppSuccess: (state) => {
      return state;
    },
    deleteAppFail: (state, action: PayloadAction<FailedResponse>) => {
      return setReducerState('error', 'appDetails', { state, error: action.payload });
    },
    regenerateSecret: (state) => {
      return state;
    },
    regenerateSecretSuccess: (state, { payload }) => {
      return {
        ...state,
        appDetails: {
          ...state.appDetails,
          data: {
            ...state.appDetails.data,
            clientSecret: payload,
          },
        },
      };
    },
    regenerateSecretFail: (state, action) => {
      return setReducerState('error', 'appDetails', { state, error: action.payload });
    },
    toogleGenerateSecretModal: (state, action) => {
      return { ...state, isVisibleSecretModal: action.payload };
    },
    toogleDeleteAppModal: (state, action) => {
      return { ...state, isVisibleDeleteAppModal: action.payload };
    },
    toogleCreateAppModal: (state, action) => {
      return { ...state, isVisibleCreateAppModal: action.payload };
    },
    setAppDescription: (state, { payload }) => {
      return { ...state, appDescription: payload };
    }
  },
});

//Selectors
export const list = (state: RootState) => state.apps.appList.data;
export const listLoaded = (state: RootState) => state.apps.appListLoaded;
export const createAppModalState = (state: RootState) => state.apps.isVisibleCreateAppModal;
export const deleteAppModalState = (state: RootState) => state.apps.isVisibleDeleteAppModal;
export const secretModalState = (state: RootState) => state.apps.isVisibleSecretModal;
export const appDetailsData = (state: RootState) => state.apps.appDetails.data;
export const appDescriptionData = (state: RootState) => state.apps.appDescription;

//Actions
export const appsActions = appDetails.actions;

//Reucers
export default appDetails.reducer;
